/**
  * Archivo: response-cfdi-documentos-idNotaFactura.model.tsx
  *   Autor: Jahaziel Jeuh Baltazar Isidoro <jahaziel.baltazar@finalsoft.com.mx>
  *   Fecha: Septiembre 25, 2023.
  */
export default class responseCFDIDocumentosIdNotaFactura {
  public pdf: string = '';
  public xml: string = '';
  public folio: string = '';
  public urlXml: string = '';
  public urlPdf: string = '';
}
